import React, { Component } from 'react';
import { Redirect} from 'react-router-dom';
import rpc, { rpcWithParams }  from './our/rpc';

export class LollapaloozaRedirect extends Component {
    componentDidMount(){
        rpc({
            type: 'IsLollapaloozaByDate',
            date: new Date()
        }).then((result) => {
            if (result > 0) {
                this.props.onChangeOffer(9);
                const value = {
                dateOcurrence: new Date(),
                pageVisited: 'Llega por la parte de Lollapalooza.',
                idOffert: 9
                };
                rpc({
                    type: 'SaveContrationStepsHistory',
                    value
                }).then((result) => {
                    this.props.onChangeContratationStep(result);
                    console.log(result);
                });
            }
        });
    }

    render() {
        return (
            <Redirect to="/Contratation" />

        )
    }
}

export default LollapaloozaRedirect